import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import template from './estimatedQuote.vue';
import moment from 'moment';
import qs from 'qs';
import tmsService from '../../services/axios/tmsService';
import UnisProductModal from '../../components/unisProductModal';
import { find, filter, forEach, map, remove } from 'lodash-es';
import tmsTransformRequestService from '../../services/axios/tmsTransformRequestService';
import switchBillingToService from '../../shared/switchBillingToService';

@Component({
    mixins: [template],
    components: {
        UnisProductModal,
    },
})
export default class EstimatedQuote extends Vue {
    @Prop()
    quoteResult: any;
    @Prop()
    isTruckload: boolean;
    quoteId: any = '';
    quoteResultConverted: any = {};
    isEditMode: boolean = false;
    isScheduleMode: boolean = false;
    isShowButtons: boolean = true;
    errorText: boolean = false;
    isLastmile: boolean = false;
    showErrTip: boolean = false;
    tipType: any = '';
    quoteState: any = '';
    quoteData: any = '';
    editProductModal: string = 'ShareEstimatedQuoteDetails';
    californiaComplianceSurcharge: string = '';
    schedulePickupAccess: Boolean = false;

    private getQuoteInfo() {
        tmsService
            .post(`/write_new/get_tms_quote_line.php`, qs.stringify({ quote_id: this.quoteId }))
            .then(
                (res: any) => {
                    this.quoteResultConverted = res.data;
                    if (this.quoteResultConverted.status_text.indexOf('Expires in') > -1) {
                        this.quoteResultConverted.status_text =
                            this.quoteResultConverted.status_text + 'd';
                    }
                    this.fillterState(this.quoteResultConverted);
                    this.fillBaseCharge(this.quoteResultConverted.lines);
                },
                (err: any) => {
                    this.showErrorFun(err.response.data.statusText);
                }
            );
    }

    getUserAccess() {
        let params: any = {
            UserID: localStorage.UserID,
            UserToken: localStorage.UserToken,
        };
        switchBillingToService.post().then(
            (res: any) => {
                if (res.data.user) {
                    res.data.user.schedule_pickup_access == 'y'
                        ? (this.schedulePickupAccess = true)
                        : (this.schedulePickupAccess = false);
                }
            },
            (err: any) => {
                console.log(err);
            }
        );
    }

    private fillBaseCharge(quoteLists: any) {
        let basicCharge = filter(quoteLists, { rate_external_text: 'Basic Charge' });

        if (basicCharge.length == 0) return;
        let amountTotals: any = 0.0;
        forEach(basicCharge, (item: any) => {
            amountTotals = amountTotals + Number(item.rate_amount_total);
        });
        remove(quoteLists, (list: any) => {
            return list.rate_external_text == 'Basic Charge';
        });

        let tms_quote_lines_calc_texts = map(basicCharge, 'tms_quote_lines_calc_text');
        let objTexts: any = [];
        forEach(tms_quote_lines_calc_texts, (text: any, index: any) => {
            if (text.indexOf('minimum') > -1) objTexts.push({ minimum: text });
            else objTexts.push({ ['product ' + (index + 1)]: text });
        });

        let basicChargeItem: any = {
            rate_external_text: 'Base Charge',
            rate_amount_total: amountTotals,
            tms_quote_lines_calc_texts: objTexts,
        };
        quoteLists.unshift(basicChargeItem);
    }

    mounted() {
        this.quoteData = this.$store.getters.quoteData;
        if (this.$route.query && this.$route.query.quoteId) {
            this.quoteId = this.$route.query.quoteId;
            this.getQuoteInfo();
        }
    }

    private fillterState(quoteResultConverted: any) {
        if (quoteResultConverted.needs_review == 'y') {
            this.quoteState = 'Needs  review';
            return;
        }
        if (quoteResultConverted.tms_quote_status == '1') {
        }
        let nowDate = moment(moment().format('YYYY-MM-DD')).unix();
        let expireDate = moment(quoteResultConverted.tms_quote_expire_date).unix();
        if (nowDate > expireDate) {
            this.quoteState = 'Expired';
        } else {
            this.quoteState = 'Deny';
        }
        if (quoteResultConverted.lines && quoteResultConverted.lines.length > 0) {
            let findItem = find(quoteResultConverted.lines, {
                rate_external_text: 'California Compliance Surcharge',
            });
            if (findItem)
                this.californiaComplianceSurcharge = findItem.rate_amount_total
                    ? findItem.rate_amount_total
                    : ' ';
            else this.californiaComplianceSurcharge = '';
        }
    }

    created() {
        this.getUserAccess();
        /*

         this.convertQuoteResult();
         console.log('quoteResultConverted:::', this.quoteResultConverted);
         let query = this.$route.query;

         this.isEditMode = query.isEdit ? true : false;
         this.isScheduleMode = query.schedule ? true : false;
         if (!isUndefined(query.isShowButtons)) {
         this.isShowButtons = query.isShowButtons === "false" ? false : true;
         }*/
    }

    showErrorFun(errText: any) {
        this.errorText = errText;
        this.showErrTip = true;
        setTimeout(() => {
            this.showErrTip = false;
            this.tipType = '';
        }, 3000);
    }

    schedulePickup() {
        let quoteType: any = '';
        if (this.quoteResultConverted.tms_quote_from == 'LAST_MILE_SERVICE') {
            quoteType = 'lastmile';
        } else {
            quoteType = 'truckload';
        }
        if (this.quoteState == 'Expired')
            this.$router.push({
                name: 'Quote',
                query: {
                    isEdit: 'true',
                    isRequestnewquote: 'true',
                    quoteType: quoteType,
                    quoteNumber: this.quoteId,
                },
            });
        else
            this.$router.replace({
                name: 'ScheduleApickup',
                params: {
                    quoteId: this.quoteResultConverted.tms_quote_id,
                },
            });
    }

    saveQuote() {
        let quoteType: any = '';
        if (this.quoteResultConverted.tms_quote_from == 'LAST_MILE_SERVICE') {
            quoteType = 'lastmile';
        } else {
            quoteType = 'truckload';
        }
        this.$router.push({
            name: 'Quote',
            query: {
                isEdit: 'true',
                quoteType: quoteType,
                quoteNumber: this.quoteResultConverted.tms_quote_id,
            },
        });
    }

    goToSavedQuotesPage() {
        window.location.href = '#/quoteList';
    }

    editQuote() {
        let quoteType = '';
        switch (this.quoteResultConverted.tms_quote_from) {
            case 'LAST_MILE_SERVICE':
                quoteType = 'lastmile';
                break;

            case 'SHARE_TRUCK_LOAD':
                quoteType = 'sharedTruckload';
                break;

            default:
                quoteType = 'truckload';
                break;
        }

        this.$router.push({
            name: 'Quote',
            query: {
                isEdit: 'true',
                quoteType: quoteType,
                quoteNumber: this.quoteResultConverted.tms_quote_id,
            },
        });
    }

    share() {
        this.editProductModal = 'ShareEstimatedQuoteDetails';
        this.$modal.show(this.editProductModal);
    }

    modalHide() {
        this.$modal.hide(this.editProductModal);
    }

    copyUrl() {
        let oInput = document.createElement('input');
        oInput.value = window.location.href;
        document.body.appendChild(oInput);
        oInput.select();
        document.execCommand('Copy');
        oInput.remove();
        this.succeed('Copy success');
    }

    fillterStatusName(foldNmae: string) {
        if (foldNmae.indexOf('Expires') > -1) {
            return 'Expired';
        } else return foldNmae;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/estimatedQuote/index.ts